import { IConfiguration } from "../domain/configuration";
import { User } from "../domain/user";

export class State {
  public token: string;
  public user: User;
  public folderGuid: string;
  public configuration: IConfiguration;
}
